export default __webpack_public_path__ + "8d8089bfdf0f485ba40a56420ecbda7b.png";